import { usePerformanceStore, type PerformanceEntryType } from "../../store/performance.store";

const noop = () => {};
const noopEnd = (_label: string, _type: PerformanceEntryType) => {};

export function usePerformanceTracker(pageName: string | undefined) {
    if (!pageName) {
        return { start: noop, end: noopEnd, clear: noop, markComplete: noop };
    }

    const perfStore = usePerformanceStore();
    const timers = new Map<string, number>();

    const start = (label: string) => {
        if (!perfStore.isEnabled) return;
        timers.set(label, performance.now());
    };

    const end = (label: string, type: PerformanceEntryType) => {
        if (!perfStore.isEnabled) return;
        const startTime = timers.get(label);
        if (startTime === undefined) return;
        const durationMs = Math.round(performance.now() - startTime);
        timers.delete(label);
        perfStore.addEntry(pageName, {
            label,
            type,
            durationMs,
            timestamp: Date.now(),
        });
    };

    const clear = () => {
        perfStore.clearPage(pageName);
        timers.clear();
    };

    const markComplete = () => {
        perfStore.markComplete(pageName);
    };

    return { start, end, clear, markComplete };
}
